import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";
import RichText from "../components/RichText";

import video from "../assets/videos/dpfsolutions1.mp4";
import imageurl1 from "../assets/images/dpf-new-1.png";
import imageurl2 from "../assets/images/dpf-new-2.png";
import video2 from "../assets/videos/service2.mp4";

function DPFSolutions() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        DPF* staat ook wel bekend als roetfilter. Dit is een filter die de
        uitlaatgassen doorlaat en de roetdeeltjes opvangt. Bij hoge temperaturen
        of lange afstanden start uw voertuig automatisch een regeneratieproces
        om de roetdeeltjes te verbranden. Dit gebeurt doordat er een hoeveelheid
        diesel in de roetfilter wordt gespoten en de roetdeeltjes worden
        vernietigd door de extreem hogetemperatuur. Dit heeft natuurlijk invloed
        op uw brandstofgebruik. Bij kortere afstanden of te lage temperaturen
        behaalt het voertuig het regeneratieproces niet, waardoor de
        roetdeeltjes niet optimaal verbranden. Dit kan ervoor zorgen dat uw
        roetfilter verstopt raakt.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">De optie die wij aanbieden;</p>
      <p className="text-white text-lg">
        - Roetfilter uitschakelen. Wij kunnen de roetfilter compleet
        uitschakelen en zullen deze volledig wegprogrammeren in de software van
        uw auto. Nadat dit gebeurd is, moet u de roetfilter laten leeghalen. Wij
        zijn gespecialiseerd in de software van het motormanagement en voeren
        dus enkel de softwarematige aanpassingen uit. De volgende opties kunt u
        niet bij ons afnemen:
      </p>
      <p className="text-white text-lg">- Roetfilter vervangen</p>
      <p className="text-white text-lg">- Roetfilter reinigen</p>
      <p className="text-white text-lg">
        Ookwillen wij u erop attenderen dat als u kiest voor één van deze opties
        er een kans bestaat dat het probleem op korte termijn weer zou kunnen
        voorkomen.
      </p>
    </>
  );

  const text3 = (
    <>
      <h3 className="text-[#BD0E0E] text-xl">LET OP!</h3>
      <br />
      <p className="text-white text-lg">
        Deze service is wegens de strenge milieunormen niet toegestaan op de
        openbare weg en is geheel op eigen risico van de klant!
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="DPF Solutions" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        heading="Watzijn de opties voor een roetfilter?"
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text3} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default DPFSolutions;
